/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignInvoicePaymentDataPaymentMethodSchema = z.enum(['Jobilla Wallet', 'Card', 'Bank Transfer'])

export type CampaignInvoicePaymentDataPaymentMethodSchema = z.infer<
	typeof campaignInvoicePaymentDataPaymentMethodSchema
>
